import { getResponsiveStyles } from '../../../component-themes';
const accordionItemButtonTitleHeadlineBase = (tokens) => ({ size, state, }) => ({
    fontSize: tokens.styles[`accordion-button-title-headline-${size}-${state}-fontSize`],
    fontWeight: tokens.styles[`accordion-button-title-headline-${size}-${state}-fontWeight`],
    fontFamily: tokens.styles[`accordion-button-title-headline-${size}-${state}-fontFamily`],
    lineHeight: tokens.styles[`accordion-button-title-headline-${size}-${state}-lineHeight`],
    letterSpacing: tokens.styles[`accordion-button-title-headline-${size}-${state}-letterSpacing`],
    opacity: tokens.styles[`accordion-button-title-headline-${size}-${state}-opacity`],
    color: tokens.styles[`accordion-button-title-headline-${size}-${state}-color`],
    lineClamp: 2,
    webkitLineClamp: 2,
    webkitBoxOrient: 'vertical',
    display: '-webkit-box',
    overflow: 'hidden',
});
export const accordionItemButtonTitleHeadline = (tokens) => ({ size, state, }) => getResponsiveStyles(size, (size) => accordionItemButtonTitleHeadlineBase(tokens)({ size, state }));
